module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/_add-to-unscopables.js
// module id = 246
// module chunks = 0